module.exports = __webpack_public_path__ + "img/foundations_session_bg.953bca3c.svg";